export default "__VITE_ASSET__sGXRkIlP__"